import * as React from 'react';
import { useEffect, useState } from 'react';

import { clearScoringData, getScoringData, updateScoringData } from '@/helpers';
import { type ScoringContextModel } from '@/models';

import { ScoringContext, type ScoringContextType } from './context';

export const ScoringProvider: React.FC<{ children: JSX.Element | null }> = ({ children }) => {
  const [scoringData, setScoringData] = useState(getScoringData());

  useEffect(() => {
    updateScoringData(scoringData);
  }, [scoringData]);

  const updateScoringDataInComponent = (payload: ScoringContextModel | null): void => {
    if (!payload) {
      return;
    }
    setScoringData((prevState) => ({
      ...prevState,
      ...payload,
    }));
  };

  const clearScoringDataInLS = (): void => {
    clearScoringData();
    setScoringData({});
  };

  const contextValue: ScoringContextType = {
    updateScoringDataInComponent,
    scoringData,
    clearScoringDataInLocalStorage: clearScoringDataInLS,
  };

  return <ScoringContext.Provider value={contextValue}>{children}</ScoringContext.Provider>;
};
